import { render, staticRenderFns } from "./ControlPayment.vue?vue&type=template&id=6a7006d1&"
import script from "./ControlPayment.vue?vue&type=script&lang=js&"
export * from "./ControlPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports